import { createTheme, responsiveFontSizes } from "@mui/material";

//export const GlobalTheme = createTheme({
const InitialGlobalTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640, // Small devices like mobile phones
      md: 768, // Medium devices like tablets
      lg: 1024, // Large devices like small desktops
      xl: 1440, // Extra-large devices like large desktops
    },
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: "64px",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#354A55",
          color: "#fff",
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: "xl", // You can set this to 'xl' if you want to use the xl breakpoint
      },
      styleOverrides: {
        maxWidthXs: {
          maxWidth: "100%", // Full width on extra small screens
        },
      },
    },
  },
  palette: {
    background: {
      default: "#E5E5E5",
    },
    primary: {
      main: "##354A55",
    },
    secondary: {
      main: "#f48fb1",
    },
    text: {
      primary: "#000000",
    },
    white: {
      main: "#ffffff",
    },
  },
  typography: {
    bannerText: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#354A55",
    },
    bannerTextDarkBg: {
      //fontSize: "2rem",
      fontWeight: "bold",
      color: "#fff",
      marginTop: "30px",
    },
  },
});

export const GlobalTheme = responsiveFontSizes(InitialGlobalTheme, {
  factor: 2,
});
